import { Box, CircularProgress, Container, Button } from '@mui/material'
import "./styles.scss";
import { useEffect, useRef, useState } from 'react';
import { ReportInterface } from 'src/stateManagement/redux/slices/gerencia_tecnica/interfaces';
import { useSelector } from 'react-redux';
import { selectGtoState } from "../../../../stateManagement/redux"
import index from '../../../pages/ali/page';
import ButtonBig from 'src/shared/components/button_big';
import JSZip from 'jszip';
import { delay } from '../../consolidate_files/upload-modal/fileRow';
import generatePDF, { Options } from 'react-to-pdf';
import { saveAs } from "file-saver";
import { setStatusValve } from 'src/shared/util/setStatusValve';

export const PhysicalCheckReport = ({ report, filters }: { report: ReportInterface, filters: any }) => {

    const mainState = useSelector(selectGtoState);
    const [loading, setLoading] = useState(false)
    const [loadingData, setLoadingData] = useState(true);
    const [showListOfActivities, setShowListOfActivities] = useState(true)
    const [setSizeToGeneratePdf, setsetSizeToGeneratePdf] = useState(false)
    const [reloadCartComponent, setReloadCartComponent] = useState(false)
    const [reportData, setReportData] = useState<any[] | undefined>([]);
    

      const [index, setIndex] = useState<number>(0);
      const total = reportData?.length || 0;

      const next = () => setIndex((i) => (i + 1) % total);
      const prev = () => setIndex((i) => (i - 1 + total) % total);



    const targetRef = useRef<any>();
    useEffect(() => {
        if (Array.isArray(mainState?.reportWithData)) {
            setReportData(mainState.reportWithData);
              setLoadingData(false);
        }

      
    }, [mainState?.reportWithData]);

    const onClickDownloadPdfV2 = async () => {
        const zip = new JSZip(); // Create a new ZIP archive
    
        if (showListOfActivities) {
          setShowListOfActivities(false);
    
          let i = 1;
    
          setLoading(true);
          for (const activity of reportData || []) {
              try {
                 
                  setReloadCartComponent(true);
                  await delay(100);
                  setsetSizeToGeneratePdf(true);
                  setReloadCartComponent(false);
                  await delay(300);

                  const options: Options = {
                      filename: `${activity?.["Pozo"]}.pdf`,
                      method: "build",
                      page: {
                          format: "letter",
                          orientation: "portrait",
                          margin: { top: 8, right: 15, bottom: 0, left: 15 },
                      },
                      overrides: { pdf: { compress: true, format: "letter" } },
                      canvas: { qualityRatio: 0.2 },
                  };

                  const pdfDoc = await generatePDF(targetRef, options);

                  // Convert jsPDF object to Blob
                  const pdfBlob = pdfDoc.output("blob");

                  // Add the generated PDF Blob to the ZIP archive
                  zip.file(`${activity?.["Pozo"]}.pdf`, pdfBlob);
                  i++;
              } catch (error) {
                  console.log({ error });
              }
          }
         
          setsetSizeToGeneratePdf(false);
          setShowListOfActivities(true);
    
          // Generate the ZIP file and trigger the download
          const zipBlob = await zip.generateAsync({ type: "blob" });
          saveAs(zipBlob, "all_activities.zip");
          setLoading(false);
        } else {
          setReloadCartComponent(true)
          await delay(500)
          setsetSizeToGeneratePdf(true)
          setReloadCartComponent(false)
          await delay(1000)
    
          const options: Options = {
              filename: `${reportData?.[0]?.["Pozo"]}.pdf`,
              method: "open",
              page: {
                  format: "letter",
                  orientation: "landscape",
                  margin: { top: 22, right: 22, bottom: 0, left: 22 },
              },
              // page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 10, bottom: 0, left: 10 } },
              overrides: { pdf: { compress: true } },
              canvas: { qualityRatio: 0.2 },
          };
          await generatePDF(targetRef, options)
          setsetSizeToGeneratePdf(false)
        }
      };


  return (
      <Container maxWidth="lg">
          <div className="container_cart_list_button_container">
              <div className="loadingSection">
                  {loading && (
                      <>
                          <CircularProgress disableShrink />
                          Generado los archivos PDF......
                      </>
                  )}
              </div>
              <div className="button_right">
                  <ButtonBig
                      text="Generar PDF"
                      icon="/assets/icons/download-report.svg"
                      onClick={() => onClickDownloadPdfV2()}
                  />
              </div>
          </div>

          {(!loadingData && reportData?.length !== 0) && (
            <>
            <div className="pozo-controls">
              <Button variant="text" color="primary" onClick={prev}>
                  Anterior
              </Button>
              <span>
                  {index + 1} / {total}
              </span>
              <Button variant="text" color="primary" onClick={next}>
                  Siguiente
              </Button>
            </div>
            <div className="pozo-carousel">
                <div className="pozo-card">
                    <Box
                        key={index}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            mt: 4,
                        }}
                    >
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr",
                                gridAutoRows: "auto",
                                width: "100%",
                                rowGap: "0px",
                            }}
                            ref={targetRef}
                        >
                            {/* header */}
                            <div
                                style={{
                                    border: "1px solid #ccc",
                                    width: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 2fr 1fr",
                                        alignItems: "center",
                                        textAlign: "center",
                                        padding: "5px",
                                        gap: "10px",
                                    }}
                                >
                                    <div
                                        style={{
                                            textAlign: "left",
                                            marginLeft: "15px",
                                        }}
                                    >
                                        <img
                                            src="/assets/icons/logo_without_text.svg"
                                            alt=""
                                            width="40px"
                                        />
                                    </div>

                                    <div
                                        style={{
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        CHEQUEO DE SUPERFICIE Y DIAGNOSTICO DE
                                        POZO
                                    </div>

                                    <div style={{ textAlign: "right" }}></div>
                                </div>
                            </div>

                            {/* info pozo */}
                            <div
                                style={{
                                    borderLeft: "1px solid #ccc",
                                    borderRight: "1px solid #ccc",
                                    borderBottom: "1px solid #ccc",
                                    width: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(3, 1fr)",
                                        padding: "10px",
                                        fontSize: "13px",
                                        alignItems: "center",
                                    }}
                                >
                                    <div>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "auto 1fr",
                                                alignItems: "center",
                                            }}
                                        >
                                            <strong>POZO:</strong>
                                            <span>
                                                {reportData?.[index]["Pozo"]}
                                            </span>
                                        </div>

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "auto 1fr",
                                                alignItems: "center",
                                            }}
                                        >
                                            <strong>MGL: </strong>
                                            <span>_________</span>
                                        </div>
                                    </div>

                                    <div>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr",
                                                alignItems: "center",
                                            }}
                                        >
                                            <strong>TIPO: </strong>
                                            <span>
                                                {
                                                    reportData?.[index][
                                                        "Tipo de Pozo"
                                                    ]
                                                }
                                            </span>
                                        </div>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr",
                                                alignItems: "center",
                                            }}
                                        >
                                            <strong>
                                                CONECTADA LINEA DE PROD / INY:
                                            </strong>
                                            <span>____________</span>
                                        </div>
                                    </div>

                                    <div>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "auto 1fr",

                                                alignItems: "center",
                                            }}
                                        >
                                            <strong>EF: </strong>
                                            <span>
                                                {reportData?.[index]["EF"]}
                                            </span>
                                        </div>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "auto 1fr",

                                                alignItems: "center",
                                            }}
                                        >
                                            <strong>AREA: </strong>
                                            <span>______</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* title conditions */}
                            <div
                                style={{
                                    borderLeft: "1px solid #ccc",
                                    borderRight: "1px solid #ccc",
                                    borderBottom: "1px solid #ccc",
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                    }}
                                >
                                    CONDICIONES DE SUPERFICIE
                                </div>
                            </div>
                            {/* conditions table */}
                            <div
                                style={{
                                    borderLeft: "1px solid #ccc",
                                    borderRight: "1px solid #ccc",
                                    borderBottom: "1px solid #ccc",
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        fontSize: "13px",
                                        width: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            position: "relative",
                                            borderRight: "1px solid #ccc",
                                            padding: "20px",
                                        }}
                                    >
                                        <img
                                            src="/assets/images/arbol.svg"
                                            alt=""
                                            width={"100%"}
                                        />
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "105px",
                                                left: "25px",
                                                padding: "4px 8px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "VALV CORONA (IN) DEL ÁRBOL"
                                                ]
                                            }
                                        </div>
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "75px",
                                                right: "52px",
                                                padding: "4px 8px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "CAJA DE CHOQUE (IN) DEL ÁRBOL"
                                                ]
                                            }
                                        </div>
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "390px",
                                                left: "25px",
                                                padding: "4px 8px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "VALV MAESTRA (IN) DEL ÁRBOL"
                                                ]
                                            }
                                        </div>
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "520px",
                                                right: "25px",
                                                padding: "4px 8px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "CSG OPUESTO (IN) DEL ÁRBOL"
                                                ]
                                            }
                                        </div>
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "660px",
                                                right: "35px",
                                                padding: "4px 8px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "CSG SUPERFICIE (IN)"
                                                ]
                                            }
                                        </div>
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "600px",
                                                left: "20px",
                                                padding: "4px 8px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "CSG INY (IN) DEL ÁRBOL"
                                                ]
                                            }
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr",
                                        }}
                                    >
                                        <div
                                            style={{
                                                borderBottom: "1px solid #ccc",
                                                display: "grid",
                                                gridTemplateColumns: "1fr",
                                                fontSize: "13px",
                                                padding: "5px",
                                            }}
                                        >
                                            <strong>
                                                CARACTERÍSTICAS DEL ÁRBOL
                                            </strong>
                                            <label>
                                                MARCA:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "MARCA DEL ÁRBOL"
                                                        ]
                                                    }
                                                </strong>
                                            </label>
                                            <label>
                                                TAMAÑO:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "TAMAÑO DEL ÁRBOL (IN)"
                                                        ]
                                                    }
                                                </strong>
                                            </label>
                                            <span>
                                                SERIE:{" "}
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "SERIE DEL ÁRBOL"
                                                        ]
                                                    }
                                                </strong>
                                            </span>
                                            <span>
                                                ALTURA:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "ALTURA DEL ÁRBOL"
                                                        ]
                                                    }
                                                </strong>
                                            </span>
                                            <span>
                                                NÚMEROS DE BRAZOS:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "No DE BRAZOS DEL ÁRBOL"
                                                        ]
                                                    }
                                                </strong>
                                            </span>
                                        </div>
                                        <div
                                            style={{
                                                borderBottom: "1px solid #ccc",
                                                display: "grid",
                                                gridTemplateColumns: "1fr",
                                                fontSize: "13px",
                                                padding: "5px",
                                            }}
                                        >
                                            <strong>CONDICIONES DEL ÁRBOL</strong>

                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "1fr 1fr",
                                                    justifyContent:
                                                        "space-between",
                                                }}
                                            >
                                                <span>
                                                    TAPA CORONA:
                                                    <strong
                                                        style={{
                                                            marginLeft: "5px",
                                                        }}
                                                    >
                                                        {
                                                            reportData?.[index][
                                                                "TAPA CORONA"
                                                            ]
                                                        }
                                                    </strong>
                                                </span>
                                                <span>
                                                    FLANGE CORONA:
                                                    <strong
                                                        style={{
                                                            marginLeft: "5px",
                                                        }}
                                                    >
                                                        {
                                                            reportData?.[index][
                                                                "FLANCHE CORONA"
                                                            ]
                                                        }
                                                    </strong>
                                                </span>
                                            </div>

                                            <label
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "auto 1fr",
                                                    fontSize: "13px",
                                                    alignItems: "start",
                                                }}
                                            >
                                                <span>
                                                    CONDICIÓN DE ROSCA INTERNA DEL
                                                    FLANCHE CORONA:
                                                </span>
                                                <span>Valor</span>
                                            </label>

                                            <span>
                                                TAPA CAJA DE CHOKE:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "TAPA CAJA DE CHOQUE"
                                                        ]
                                                    }
                                                </strong>
                                            </span>

                                            <span>MARCA CAJA DE CHOQUE:</span>

                                            {/* otro bloque de dos columnas */}
                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "1fr 1fr",
                                                    justifyContent:
                                                        "space-between",
                                                    fontSize: "13px",
                                                }}
                                            >
                                                <span>
                                                    VÁLVULA INTELIGENTE:
                                                    <strong
                                                        style={{
                                                            marginLeft: "5px",
                                                        }}
                                                    >
                                                        {
                                                            reportData?.[index][
                                                                "VALV INTELIGENTE"
                                                            ]
                                                        }
                                                    </strong>
                                                </span>
                                                <span>
                                                    VÁLVULA SAFEMATIC:
                                                    <strong
                                                        style={{
                                                            marginLeft: "5px",
                                                        }}
                                                    >
                                                        {
                                                            reportData?.[index][
                                                                "VALV SAFEMATIC"
                                                            ]
                                                        }
                                                    </strong>
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr", // una sola columna principal // espacio vertical entre filas
                                                fontSize: "13px",
                                            }}
                                        >
                                            <strong>
                                                CONDICIONES DE LA VÁLVULA DEL
                                                ÁRBOL
                                            </strong>

                                            {/* encabezado */}
                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "200px 1fr 1fr",
                                                    alignItems: "center",
                                                    fontSize: "13px",
                                                }}
                                            >
                                                <strong
                                                    style={{
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    VÁLVULA
                                                </strong>
                                                <strong
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    OPERABLE
                                                </strong>
                                                <strong
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    SELLA
                                                </strong>
                                            </div>

                                            {/* filas de datos */}
                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "200px 1fr 1fr",
                                                    fontSize: "13px",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span>MAESTRA:</span>
                                                <span
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {setStatusValve(
                                                        reportData?.[index][
                                                            "VALV MAESTRA"
                                                        ]
                                                    ) && <strong>X</strong>}
                                                </span>
                                                <span
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {setStatusValve(
                                                        reportData?.[index][
                                                            "VALV MAESTRA"
                                                        ]
                                                    ) && <strong>X</strong>}
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "1fr 1fr 1fr",

                                                    fontSize: "13px",
                                                }}
                                            >
                                                <span>CORONA:</span>
                                                <span></span>
                                                <span></span>
                                            </div>

                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "200px 1fr 1fr",

                                                    fontSize: "13px",
                                                }}
                                            >
                                                <span>BRAZO PRODUCCIÓN:</span>
                                                <span
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {setStatusValve(
                                                        reportData?.[index][
                                                            "VALV BRAZO PRODUCCIÓN"
                                                        ]
                                                    ) && <strong>X</strong>}
                                                </span>
                                                <span
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {setStatusValve(
                                                        reportData?.[index][
                                                            "VALV BRAZO PRODUCCIÓN"
                                                        ]
                                                    ) && <strong>X</strong>}
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "200px 1fr 1fr",

                                                    fontSize: "13px",
                                                }}
                                            >
                                                <span>BRAZO PROD OPUESTO:</span>
                                                <span
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {setStatusValve(
                                                        reportData?.[index][
                                                            "VALV BRAZO PRODUCCIÓN OPUESTO"
                                                        ]
                                                    ) && <strong>X</strong>}
                                                </span>
                                                <span
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {setStatusValve(
                                                        reportData?.[index][
                                                            "VALV BRAZO PRODUCCIÓN OPUESTO"
                                                        ]
                                                    ) && <strong>X</strong>}
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "200px 1fr 1fr",

                                                    fontSize: "13px",
                                                }}
                                            >
                                                <span>CASING INYECCIÓN:</span>
                                                <span
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {setStatusValve(
                                                        reportData?.[index][
                                                            "VALV CASING INYECCIÓN"
                                                        ]
                                                    ) && <strong>X</strong>}
                                                </span>
                                                <span
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {setStatusValve(
                                                        reportData?.[index][
                                                            "VALV CASING INYECCIÓN"
                                                        ]
                                                    ) && <strong>X</strong>}
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "200px 1fr 1fr",

                                                    fontSize: "13px",
                                                }}
                                            >
                                                <span>CASING OPUESTO:</span>
                                                <span
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {setStatusValve(
                                                        reportData?.[index][
                                                            "VALV CASING OPUESTO"
                                                        ]
                                                    ) && <strong>X</strong>}
                                                </span>
                                                <span
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {setStatusValve(
                                                        reportData?.[index][
                                                            "VALV CASING OPUESTO"
                                                        ]
                                                    ) && <strong>X</strong>}
                                                </span>
                                            </div>

                                            <span>
                                                FACILIDAD PARA DESPRESURIZAR
                                                CASING:
                                                <strong
                                                    style={{
                                                        marginLeft: "10px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "FACILIDAD PARA DESPRESURIZAR CASING"
                                                        ]
                                                    }
                                                </strong>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                style={{
                                    borderLeft: "1px solid #ccc",
                                    borderRight: "1px solid #ccc",
                                    borderBottom: "1px solid #ccc",
                                    width: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        width: "100%",
                                        padding: "5px",
                                    }}
                                >
                                    <div
                                        style={{
                                            borderRight: "1px solid #ccc",
                                            display: "grid",
                                            gridTemplateColumns: "1fr",
                                            fontSize: "13px",
                                        }}
                                    >
                                        <strong>
                                            CONDICIONES DE LA PLATAFORMA
                                        </strong>
                                        <span>
                                            TIPO DE PLATAFORMA:
                                            <strong
                                                style={{
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                {
                                                    reportData?.[index][
                                                        "TIPO DE PLATAFORMA"
                                                    ]
                                                }
                                            </strong>
                                        </span>
                                        <span>
                                            CONDICIÓN DEL PISO:
                                            <strong
                                                style={{
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                {
                                                    reportData?.[index][
                                                        "COND DEL PISO"
                                                    ]
                                                }
                                            </strong>
                                        </span>
                                        <span>
                                            CONDICIÓN DEL NUMERO DE POZO:
                                            <strong
                                                style={{
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                {
                                                    reportData?.[index][
                                                        "COND DEL NÚMERO"
                                                    ]
                                                }
                                            </strong>
                                        </span>
                                        <span>
                                            BARANDAS ¿CUANTAS?:
                                            <strong
                                                style={{
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                {
                                                    reportData?.[index][
                                                        "NÚMERO DE BARANDAS"
                                                    ]
                                                }
                                            </strong>
                                        </span>
                                        <span>
                                            BARANDAS SOLDADAS:
                                            <strong
                                                style={{
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                {
                                                    reportData?.[index][
                                                        "BARANDAS SOLDADAS"
                                                    ]
                                                }
                                            </strong>
                                        </span>

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr",
                                                fontSize: "13px",
                                            }}
                                        >
                                            <span>
                                                GRUA:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {reportData?.[index]["GRÚA"]}
                                                </strong>
                                            </span>
                                            <span>
                                                GIN POLE:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "GIN POLE"
                                                        ]
                                                    }
                                                </strong>
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            padding: "5px",
                                            display: "grid",
                                            gridTemplateColumns: "1fr",
                                            fontSize: "13px",
                                        }}
                                    >
                                        <strong>CONDICIONES DEL POZO</strong>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns:
                                                    "1fr 1fr 1fr",
                                                columnGap: "10px",
                                            }}
                                        >
                                            <span>
                                                ABIERTO:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {reportData?.[index][
                                                        "Condición Pozo"
                                                    ] === "Abierto" && "X"}
                                                </strong>
                                            </span>
                                            <span>
                                                FLUYENDO:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {reportData?.[index][
                                                        "Condición Pozo"
                                                    ] === "Fluyendo" && "X"}
                                                </strong>
                                            </span>
                                            <span>
                                                CERRADO:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {reportData?.[index][
                                                        "Condición Pozo"
                                                    ] === "Cerrado" && "X"}
                                                </strong>
                                            </span>
                                        </div>

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns:
                                                    "1fr 1fr 1fr",
                                                fontSize: "13px",
                                            }}
                                        >
                                            <span>
                                                DIÁMETRO LINEA DE GAS LIFT:
                                            </span>
                                            <span>CONECTADA:</span>
                                            <span>ABIERTA:</span>
                                        </div>

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns:
                                                    "1fr 1fr 1fr",
                                                fontSize: "13px",
                                            }}
                                        >
                                            <span>N° DE LÍNEAS DE FLUJO: </span>
                                            <span>CONECTADA:</span>
                                            <span>ABIERTA:</span>
                                        </div>

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr",
                                                fontSize: "13px",
                                            }}
                                        >
                                            <span>
                                                DIÁMETRO LINEA DE FLUJO:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "DIÁMETRO LÍNEA DE FLUJO (IN)"
                                                        ]
                                                    }
                                                </strong>
                                            </span>
                                            <span>
                                                CONDICIÓN LF:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "Condición LF"
                                                        ]
                                                    }
                                                </strong>
                                            </span>
                                        </div>

                                        <span>
                                            CONDICIÓN LINEA DE GAS LIFT:
                                            <strong
                                                style={{
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                {
                                                    reportData?.[index][
                                                        "Condición Línea de Gas Lift"
                                                    ]
                                                }
                                            </strong>
                                        </span>
                                        <span>
                                            NUMERO DE CENTRALIZADORES:
                                            <strong
                                                style={{
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                {
                                                    reportData?.[index][
                                                        "NÚMERO DE CENTRALIZADORES DEL POZO"
                                                    ]
                                                }
                                            </strong>
                                        </span>
                                        <span>
                                            CONDICIONES DE CENTRALIZADORES:
                                            <strong
                                                style={{
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                {
                                                    reportData?.[index][
                                                        "COND DE CENTRALIZADORES"
                                                    ]
                                                }
                                            </strong>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div
                                style={{
                                    borderLeft: "1px solid #ccc",
                                    borderRight: "1px solid #ccc",
                                    borderBottom: "1px solid #ccc",
                                    width: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        width: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            borderRight: "1px solid #ccc",
                                            padding: "5px",
                                            display: "grid",
                                            gridTemplateColumns: "1fr",
                                            fontSize: "13px",
                                        }}
                                    >
                                        <strong>MÉTODO DE PRODUCCIÓN</strong>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns:
                                                    "1fr 1fr 1fr",
                                                fontSize: "13px",
                                            }}
                                        >
                                            <span>L.A.G PTL:</span>
                                            <span>L.A.G PAL:</span>
                                            <span>B.E.S:</span>
                                        </div>

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns:
                                                    "1fr 1fr 1fr",
                                                fontSize: "13px",
                                            }}
                                        >
                                            <span>B.C.P:</span>
                                            <span>B.MEC:</span>
                                            <span>FLUJO NATURAL:</span>
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            padding: "20px",
                                            display: "grid",
                                            gridTemplateColumns: "1fr",
                                            fontSize: "13px",
                                        }}
                                    >
                                        <strong>
                                            CONDICIONES DEL ATRACADERO
                                        </strong>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr ",
                                                fontSize: "13px",
                                            }}
                                        >
                                            <span>
                                                PISO:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {reportData?.[index]["PISO"]}
                                                </strong>
                                            </span>
                                            <span>
                                                ACCESO:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "ACCESO"
                                                        ]
                                                    }
                                                </strong>
                                            </span>
                                        </div>

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr",
                                                fontSize: "13px",
                                            }}
                                        >
                                            <span>
                                                ESCALERA DE ACCESO:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "ESCALERA DE ACCESO"
                                                        ]
                                                    }
                                                </strong>
                                            </span>
                                            <span>FALTAN PELDAÑOS:</span>
                                        </div>

                                        <span>
                                            DEFENSAS:
                                            <strong
                                                style={{
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                {
                                                    reportData?.[index][
                                                        "¿TIENE DEFENSAS?"
                                                    ]
                                                }
                                            </strong>
                                            ¿CUANTAS?:
                                            <strong
                                                style={{
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                {
                                                    reportData?.[index][
                                                        "CANTIDAD DE DEFENSAS"
                                                    ]
                                                }
                                            </strong>
                                        </span>

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr",
                                                fontSize: "13px",
                                            }}
                                        >
                                            <span>
                                                CACHOLAS:
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {
                                                        reportData?.[index][
                                                            "CACHOLAS"
                                                        ]
                                                    }
                                                </strong>
                                                <strong
                                                    style={{
                                                        marginLeft: "5px",
                                                    }}
                                                >
                                                    {reportData?.[index][
                                                        "CANTIDAD DE CACHOLAS TOTALES"
                                                    ] !== "S/I" &&
                                                        `DE ${reportData?.[index]["CANTIDAD DE CACHOLAS TOTALES"]}`}
                                                </strong>
                                            </span>
                                            <label
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "1fr 50px",
                                                    columnGap: "8px",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                    alignItems: "start",
                                                }}
                                            >
                                                CONDICIÓN DE LAS CACHOLAS:
                                                <span>X</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* title conditions specific*/}
                            <div
                                style={{
                                    borderLeft: "1px solid #ccc",
                                    borderRight: "1px solid #ccc",
                                    borderBottom: "1px solid #ccc",
                                    width: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                    }}
                                >
                                    CONDICIONES ESPECIFICAS
                                </div>
                            </div>

                            <div
                                style={{
                                    borderLeft: "1px solid #ccc",
                                    borderRight: "1px solid #ccc",
                                    borderBottom: "1px solid #ccc",
                                    width: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        fontSize: "13px",
                                        padding: "5px",
                                    }}
                                >
                                    <span>
                                        ¿SE OBSERVO FUGA?:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "¿SE OBSERVÓ FUGA?"
                                                ]
                                            }
                                        </strong>
                                    </span>
                                    <span>
                                        UBICACIÓN DE LA FUGA:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "UBICACIÓN DE LA FUGA"
                                                ]
                                            }
                                        </strong>
                                    </span>
                                </div>

                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        fontSize: "13px",
                                        padding: "5px",
                                    }}
                                >
                                    <span>
                                        TIPO DE FUGA:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {reportData?.[index]["TIPO DE FUGA"]}
                                        </strong>
                                    </span>
                                    <span>
                                        TIENE MESA DE CHOKE:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "¿TIENE MESA CHOKE?"
                                                ]
                                            }
                                        </strong>
                                    </span>
                                </div>

                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        fontSize: "13px",
                                        padding: "5px",
                                    }}
                                >
                                    <span>
                                        PUEDEN REALIZAR TRABAJOS DE SUBSUELO?:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "¿SE PUEDEN REALIZAR OPERACIONES DE SUBSUELO?"
                                                ]
                                            }
                                        </strong>
                                    </span>
                                    <span>
                                        EXISTEN EQUIPOS SOBRE LA PLATAFORMA:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "¿EXISTEN EQUIPOS SOBRE LA PLATAFORMA?"
                                                ]
                                            }
                                        </strong>
                                    </span>
                                </div>

                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        fontSize: "13px",
                                        padding: "5px",
                                    }}
                                >
                                    <span>¿POR QUE?:</span>
                                    <span>
                                        TIENE WELL HEAD MONITOR?:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "¿TIENE WELL HEAD MONITOR?"
                                                ]
                                            }
                                        </strong>
                                    </span>
                                </div>
                            </div>

                            <div
                                style={{
                                    borderLeft: "1px solid #ccc",
                                    borderRight: "1px solid #ccc",
                                    borderBottom: "1px solid #ccc",
                                    width: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        fontSize: "13px",
                                        padding: "5px",
                                    }}
                                >
                                    <span>
                                        OBSERVACIONES:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {reportData?.[index]["Observaciones"]}
                                        </strong>
                                    </span>
                                    <span>
                                        UBICACIÓN DE LA FUGA:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "UBICACIÓN DE LA FUGA"
                                                ]
                                            }
                                        </strong>
                                    </span>
                                </div>

                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        padding: "5px",
                                        fontSize: "13px",
                                    }}
                                >
                                    <span>
                                        TIPO DE FUGA:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {reportData?.[index]["TIPO DE FUGA"]}
                                        </strong>
                                    </span>
                                    <span>
                                        TIENE MESA DE CHOKE:
                                        <strong
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            {
                                                reportData?.[index][
                                                    "¿TIENE MESA CHOKE?"
                                                ]
                                            }
                                        </strong>
                                    </span>
                                </div>

                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr",
                                        fontSize: "13px",
                                        padding: "5px",
                                        justifyItems: "center",
                                        alignItems: "center",
                                        textAlign: "center",
                                        marginTop: "30px",
                                    }}
                                >
                                    <span>NOMBRE:</span>
                                    <span>FIRMA:</span>
                                    <span>FECHA:</span>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </div>
           </>
          )}
         
      </Container>
  );
}
